import i18n from "i18n-js";

export const useStatisticInputs = () => {
  return {
    medicalCenter: {
      name: 'medicalCenter',
      label: i18n.t('general.medicalCenter'),
      options: [],
    },
    start: {
      name: 'start',
      label: i18n.t('general.from'),
    },
    end: {
      name: 'end',
      label: i18n.t('general.to'),
    }
  }

}